module.exports = __webpack_public_path__ + "fonts/fontello.ff3c130.woff2";